import { render, staticRenderFns } from "./NumberCell.vue?vue&type=template&id=4790b959&scoped=true"
import script from "./NumberCell.vue?vue&type=script&lang=js"
export * from "./NumberCell.vue?vue&type=script&lang=js"
import style0 from "./NumberCell.vue?vue&type=style&index=0&id=4790b959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4790b959",
  null
  
)

export default component.exports